import React from "react";
import RoleLaDokumentacija from "./RoleLaDokumentacija";
import RoleRestDokumentacija from "./RoleRestDokumentacija";

const Dokumentacija = () => {
  const role = JSON.parse(localStorage.getItem("currentUser")).role;

  return role === "Leasing admin" ? (
    <RoleLaDokumentacija />
  ) : (
    <RoleRestDokumentacija />
  );
};

export default Dokumentacija;
